module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAYAAAC9pNwMAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD6SURBVHgB7ZfhDYIwEEYPYQBH6AhsIBOATIBO4Ag4AhuIE5AygWygGzCCCwB+GPUHUm3TQmLsS5pLaOGFHtcWhyTgnOeO4yRkkIXMINPSHo/UyNEq0iNFY6riKgzDnDQoy7KfPSY11VPwf+JXjjH3BwT2aXDXdbtHjqRommYbx3EtFBdFwRA29AWUlU8KuK67RshIJB7A8WZX0uBZ93jOUjTGG7kpQ8mcSAOZdNhysmIr/n2x6n6sSoLFZDW45k8uxirISLDxTCrGWn1GuNDcYsCjKNqPddhymo23HOODSFWON8bEIKAZuIv7Axn+j46ou4DMUbdtm4s6b0ifQkwcOHtQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support/copy.png
// module id = mUm2
// module chunks = 0